"use strict";

exports.__esModule = true;
exports.TabsFields = TabsFields;
var _core = require("@blueprintjs/core");
var _icons = require("@blueprintjs/icons");
var _react = _interopRequireDefault(require("react"));
var _Translator = require("../../Core/Translator");
var _widget = require("../Tab/widget");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
/**
 * Fields for TabsElement.
 */
function TabsFields(props) {
  var element = props.element,
    path = props.path,
    elementEditor = props.elementEditor;
  return /*#__PURE__*/_react["default"].createElement(_Translator.Translator, null, function (_ref) {
    var translate = _ref.translate;
    return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(_core.FormGroup, {
      label: translate("TabsFields.orientation.label", "Orientation")
    }, /*#__PURE__*/_react["default"].createElement("div", {
      className: _core.Classes.HTML_SELECT
    }, /*#__PURE__*/_react["default"].createElement("select", {
      value: element.props.orientation || "",
      onChange: function onChange(e) {
        return elementEditor.setProp(path, "orientation", e.target.value);
      }
    }, /*#__PURE__*/_react["default"].createElement("option", {
      value: "horizontal"
    }, translate("TabsFields.orientation.horizontal.label", "Horizontal")), /*#__PURE__*/_react["default"].createElement("option", {
      value: "vertical"
    }, translate("TabsFields.orientation.vertical.label", "Vertical"))))), /*#__PURE__*/_react["default"].createElement(_core.Button, {
      icon: _icons.IconNames.ADD,
      text: translate("TabFields.addTabButton.text", "Add Tab"),
      onClick: function onClick() {
        elementEditor.appendElementAt(path, _widget.TabWidget.createElement({
          title: "Tab " + (element.children.length + 1)
        }));
      }
    }));
  });
}